var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonSentimentHappy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1206.000000, -2311.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Sentiment/Happy",
    transform: "translate(1206.000000, 2311.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.693,13.547 C23.104,13.547 22.627,13.069 22.627,12.48 C22.627,11.891 23.104,11.413 23.693,11.413 C24.282,11.413 24.759,11.891 24.759,12.48 C24.759,13.069 24.282,13.547 23.693,13.547 L23.693,13.547 Z M16,21.92 C13.172,21.92 10.88,19.628 10.88,16.8 L12.746,16.8 C12.746,18.597 14.203,20.054 16,20.054 C17.797,20.054 19.253,18.597 19.253,16.8 L21.12,16.8 C21.12,19.628 18.828,21.92 16,21.92 L16,21.92 Z M8.306,13.547 C7.717,13.547 7.24,13.069 7.24,12.48 C7.24,11.891 7.717,11.413 8.306,11.413 C8.896,11.413 9.373,11.891 9.373,12.48 C9.373,13.069 8.896,13.547 8.306,13.547 L8.306,13.547 Z M16,0 C14.343,0 12.745,0.252 11.242,0.719 C10.24,1.031 9.28,1.439 8.373,1.931 C6.559,2.917 4.958,4.242 3.653,5.822 C1.371,8.589 0,12.134 0,16 C0,24.837 7.163,32 16,32 C24.837,32 32,24.837 32,16 L32,0 L16,0 Z",
    id: 195
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonSentimentHappy);
export default __webpack_public_path__ + "static/media/common-sentiment-happy.36afd61d.svg";
export { ForwardRef as ReactComponent };